import { render, staticRenderFns } from "./ReductionVideoModal.vue?vue&type=template&id=e1ed0142"
import script from "./ReductionVideoModal.vue?vue&type=script&lang=js"
export * from "./ReductionVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports